import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromCharityForms from './charity-forms.reducers';

export interface CharityFormsState {
  stateData: fromCharityForms.State;
}

export interface State extends fromRoot.AppState {
  charityForms: CharityFormsState;
}

export const reducers = {
  stateData: fromCharityForms.reducer
};

export const selectCharityFormsState = createFeatureSelector<CharityFormsState>('charityForms');

export const selectCharityFormsStateData = createSelector(selectCharityFormsState, (state: CharityFormsState) => state.stateData);

export const getCharityFormsState = createSelector(selectCharityFormsStateData, fromCharityForms.getStateData);

export const getCharityFormsScreenError = createSelector(selectCharityFormsStateData, fromCharityForms.getError);

export const getCharityFormsScreenPending = createSelector(selectCharityFormsStateData, fromCharityForms.getPending);